module.exports = __webpack_public_path__ + "img/65.896e7ff2.svg";